import mainInstance from 'api/mainInstance';

const NotificationsAPI = {
  getNotifications: () => mainInstance.get(`/notifications?limit=99`),
  deleteNotification: (id) => mainInstance.delete(`/notifications/${id}`),
  deleteNotifications: () => mainInstance.delete(`/notifications/`, { data: { all: true } }),
};

export default NotificationsAPI;
